/**
 * Chat-translation proxy (old-cockpit "Translate Chat"). The Google API key
 * lives server-side only; this resource batches visible chat texts through
 * the authenticated backend endpoint.
 */

import type { HttpClient } from '../httpClient';
import { endpoints } from '../endpoints';

export interface TranslationItem {
  text: string;
  detectedSourceLanguage?: string | null;
}

export class TranslateResource {
  constructor(private readonly http: HttpClient) {}

  /** Translate up to 20 texts to `target` (source auto-detected when omitted). */
  batch(texts: string[], target: string, source?: string): Promise<{ items: TranslationItem[] }> {
    return this.http.post(endpoints.translate(), { texts, target, source });
  }

  /** Whether translation is configured for this workspace (gates the "Translate chat" toggle). */
  available(): Promise<{ available: boolean }> {
    return this.http.get(endpoints.translateAvailable());
  }
}
